
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOwnableProductsByLegacyProductIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"legacyProductIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_ProductId_Input"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"OwnableProductQueries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findLatestByLegacyProductIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"legacyProductIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"legacyProductIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnableProductByLegacyProductIds"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnableProductByLegacyProductIds"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_OwnableProductTuple"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentConfiguration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentScheme"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_InstallmentPaymentScheme"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnableProductInstallmentPaymentScheme"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_OneTimePaymentScheme"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownershipDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refundDays"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_SubscriptionPaymentScheme"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingCycle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfTrialDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refundDays"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownableProduct"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productType"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnableProductInstallmentPaymentScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_InstallmentPaymentScheme"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeCadence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfInstallments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfTrialDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownershipDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refundDays"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":1058}};
    doc.loc.source = {"body":"query FindOwnableProductsByLegacyProductIds($legacyProductIds: [OwnableProduct_ProductId_Input!]!) {\n  OwnableProductQueries {\n    findLatestByLegacyProductIds(legacyProductIds: $legacyProductIds) {\n      ...OwnableProductByLegacyProductIds\n    }\n  }\n}\n\nfragment OwnableProductByLegacyProductIds on OwnableProduct_OwnableProductTuple {\n  price {\n    amount {\n      currencyCode\n      value\n    }\n  }\n  fulfillmentConfiguration {\n    isActive\n    paymentScheme {\n      ... on OwnableProduct_InstallmentPaymentScheme {\n        ...OwnableProductInstallmentPaymentScheme\n      }\n      ... on OwnableProduct_OneTimePaymentScheme {\n        ownershipDays\n        refundDays\n      }\n      ... on OwnableProduct_SubscriptionPaymentScheme {\n        billingCycle\n        numberOfTrialDays\n        refundDays\n      }\n    }\n  }\n  ownableProduct {\n    productItemId\n    productType\n  }\n}\n\nfragment OwnableProductInstallmentPaymentScheme on OwnableProduct_InstallmentPaymentScheme {\n  chargeCadence\n  numberOfInstallments\n  numberOfTrialDays\n  ownershipDays\n  refundDays\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FindOwnableProductsByLegacyProductIds"] = oneQuery(doc, "FindOwnableProductsByLegacyProductIds");
        
        module.exports["OwnableProductByLegacyProductIds"] = oneQuery(doc, "OwnableProductByLegacyProductIds");
        
        module.exports["OwnableProductInstallmentPaymentScheme"] = oneQuery(doc, "OwnableProductInstallmentPaymentScheme");
        
